import PerceptLogoSmall from 'src/assets/icons/percept-logo-small.svg';
import BurgerIcon from 'src/assets/icons/burger-icon.svg';
import React from 'react';

interface HeaderProps {
    onBurgerClick: () => void;
}
export default function Header({onBurgerClick}: HeaderProps) {
    return (
        <>
            <div className='flex justify-between bg-[#293056] p-4 md:hidden'>
                <img src={PerceptLogoSmall} alt='perceptogosmall' />
                <img
                    className='cursor-pointer'
                    src={BurgerIcon}
                    alt='burgericon'
                    width={24}
                    height={24}
                    onClick={onBurgerClick}
                />
            </div>
        </>
    );
}
